<template>
    <div class="blog-cat-grid">
        <article class="post" v-for="note in notes" :key="note._id || note.id">
            <a :href="href(note)" style="display:contents;text-decoration:none;color:inherit;">
                <div class="p-img">
                    <img v-if="thumb(note)" :src="thumb(note)" :alt="note.name" loading="lazy"
                        style="width:100%;height:100%;object-fit:cover;" />
                    <div v-else class="ph"><span class="ph-lbl">{{ note.name }}</span></div>
                </div>
                <div class="p-cat" v-if="category(note)">{{ category(note) }}</div>
                <h3>{{ note.name }}</h3>
                <p>{{ note.short_description }}</p>
                <span class="link-arrow">Leer más <span class="arw">&rarr;</span></span>
            </a>
        </article>
    </div>
</template>

<script>
const CDN_BASE = 'https://lubricantesrino-208fe.kxcdn.com/api/public/v1/assets/';

export default {
    props: {
        notes: {
            type: Array,
            required: true,
        },
    },

    methods: {
        href(note) {
            return `/blog/${note.slug}`;
        },

        category(note) {
            return (note.tags && note.tags.length) ? note.tags[0] : null;
        },

        thumb(note) {
            const value = note.thumbnail || note.banner;
            let slug = null;
            if (value == null) slug = null;
            else if (typeof value === 'object') slug = value.slug;
            else if (typeof value === 'string') slug = value;
            return slug ? `${CDN_BASE}${slug}` : null;
        }
    }
};
</script>
